import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import {faCalendarAlt} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'sanremo-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.css']
})
export class DateTimePickerComponent extends FieldType {

	faCalenderAlt = faCalendarAlt;

}
